import clsx from 'clsx';

import { CloseIcon } from '../icons/close';
import { Button } from './button';
import { Typography } from './typography';

interface TagProps {
  className?: string;
  icon?: string;
  text?: React.ReactNode;
  onClose?: () => void;
}

export function Tag({ className, icon, text, onClose }: TagProps) {
  return (
    <div
      className={clsx(
        'flex h-6 w-fit items-center justify-center gap-1 rounded-full px-2 whitespace-nowrap',
        className,
      )}
    >
      {icon && <img src={icon} alt="" />}
      {text && (
        <Typography variant="small1" className="!text-fx-neutral-600 px-1">
          {text}
        </Typography>
      )}
      {onClose && (
        <Button
          variant="ghost"
          className="h-auto !p-0 hover:bg-transparent"
          onClick={onClose}
        >
          <CloseIcon className="text-fx-neutral-600" />
        </Button>
      )}
    </div>
  );
}
